import ResizeListener from 'element-resize-detector';
export default {
  methods: {
    chartEleResizeListener() { 
      const chartInstance = ResizeListener({
        strategy: 'scroll',
        callOnAdd: true
      });
      chartInstance.listenTo(this.$el, () => {
        if (!this.chart) return;
        this.chart.resize();  
      });
    },
    windowResizeListener() { 
      if (!this.chart) return;
      this.chart.resize();
    }
  },
  mounted() {
    window.addEventListener('resize', this.windowResizeListener);
    this.chartEleResizeListener();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.windowResizeListener);
  }
}